/**
 * Licensed Materials - Property of IBM	
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.	
 */

define([
	'react',
	'baglass/app/plugins/GlassPlugin',
	'ca-content/bridge/nls/StringResources',
	'ca-content/glass/glass',
], (React, GlassPluginController, StringResources, glass) => {

	const { SearchHelper, close32 } = glass;
	const SEARCH_PERSPECTIVE = 'searchContent';

	function getCurrentValue(glassContext) {
		if (glassContext.getCurrentPerspective() === SEARCH_PERSPECTIVE) {
			// searchBar renders before the content view, so get the searchTerm from the perspectiveModel
			const spec = glassContext.currentAppView.perspectiveModel.spec;
			const content = spec && spec.content || {};
			return content.searchTerm || '';
		} else if ($('.ba-autoComplete-searchBar input').length > 0) {
			// create new appView for the first time, try to get value from previous view
			return $('.ba-autoComplete-searchBar input').val();
		}
		return '';
	}

	return class SearchBarController extends GlassPluginController {

		initialize(options) {
			this.plugin = options.target.plugin;
			this.glassContext = options.glassContext;
			this.searchHelper = new SearchHelper({ glassContext: options.glassContext });
			this.currentPerspective = this.glassContext.currentPerspective;
			this.eventRouter = this.glassContext.getCoreSvc('.Events');
			this.eventRouter.on('globalSearch:valueChange', this.updateSearchBarValue, this);
			this.savedSearch = options.savedSearch || [];
			const initialValue = getCurrentValue(options.glassContext);
			if (initialValue) {
				this.plugin.setValue(initialValue);
			}
		}

		// <Search Action Controller API>
		doSearch(context) {
			const value = context.target.plugin.getValue();
			const currentFolderId = this.currentPerspective && this.currentPerspective.currentContentView && this.currentPerspective.currentContentView.folder;
			let searchString = typeof value === 'string' ? value : value.value;
			let content = {};
			try {
				let parsedValue = JSON.parse(searchString);
				if (parsedValue.query || parsedValue.name) {
					searchString = parsedValue.query || parsedValue.name;

					if (parsedValue.filterType) {
						content.filterType = parsedValue.filterType;
					}
					if (parsedValue.filterModified) {
						content.filterModified = parsedValue.filterModified;
					}
					if (parsedValue.filterSearchString) {
						content.filterSearchString = parsedValue.filterSearchString;
					}
					context.target.plugin.setValue(searchString);
					this.eventRouter.trigger('globalSearch:valueChange', { searchTerm });
				}
			} catch {
				//If the parse failed, then only a search string is present
			}
			const searchTerm = searchString.trim();
			content.searchTerm = searchTerm;
			if(currentFolderId) {
				content.currentFolderId = currentFolderId
			}
			return this.glassContext.openAppView(SEARCH_PERSPECTIVE, {
				content: content
			});
		}

		onChange(context) {
			const searchTerm = context.evt;
			context.target.plugin.setValue(searchTerm)
			const currentFolderId = this.currentPerspective && this.currentPerspective.currentContentView && this.currentPerspective.currentContentView.folder;
			// trigger value change events to sync the searchBar value across other appViews
			this.eventRouter.trigger('globalSearch:valueChange', { searchTerm });
			if (searchTerm.length > 0) {
				return this._getSuggestions(context, searchTerm, currentFolderId);
			} else {
				return this._getSavedSearch(context);
			}
		}

		onFocus(context) {
			const value = context.target.plugin.getValue();
			if (value.length > 0) {
				return this._getSuggestions(context, value);
			} else {
				return this._getSavedSearch(context);
			}
		}
		// </Search Action Controller API>

		_getSuggestions(context, searchTerm, currentFolderId) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				this._searchTerm = searchTerm;
				return this.searchHelper.getSuggestions(searchTerm, currentFolderId).then(suggestions => {
					if (this._searchTerm !== searchTerm) return; // short-circuit stale results
					const values = suggestions.map(suggestion => ({
						group: StringResources.get('searchSuggestions'),
						label: suggestion,
						value: suggestion
					}));
					context.target.plugin.setValues(values);
				});
			}, 50);
		}

		_getSavedSearch(context) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				return this.searchHelper.getSavedSearch().then(savedSearches => {
					const values = savedSearches.map(savedSearch => {
						return {
							group: StringResources.get('savedSearch'),
							label: savedSearch.name,
							value: JSON.stringify(savedSearch),
							icon: close32.id,
							onIconClick: (e) => { this.onIconClick(e, savedSearch.url, savedSearch.name, context); }
						};
					});
					this.savedSearch = values;
					context.target.plugin.setValues(values);
				});
			}, 50);
		}

		updateSearchBarValue(options) {
			this.plugin && this.plugin.setValue(options.searchTerm);
		}

		onIconClick(e, url, searchTerm, context) {
			e.stopPropagation();
			e.preventDefault();
			this.updateSaveSearch(context, searchTerm);
			return this.searchHelper.deleteSavedSearch(url, searchTerm);
		}

		updateSaveSearch(context, searchTerm) {
			let savedSearchValues = Object.assign([], this.savedSearch);
			const index = savedSearchValues && savedSearchValues.findIndex((item) => item.label === searchTerm);
			if (index > -1) {
				savedSearchValues.splice(index, 1);
				context.target.plugin.setValues(savedSearchValues);
				this.savedSearch = savedSearchValues;
			} else {
				context.target.plugin.setValue('');
			}
		}
	};

});